import { computed } from 'vue'
import { useLogger } from 'vue-logger-plugin'
import { useRouter } from 'vue-router'

import { useUtil } from '@/composables/util'
import store from '@/store'

/**
 * State and actions shared by the app-bar account menus (AppBarAccountMenu, AppBarHamburger).
 * Must be called from a component's setup, since it needs the router and logger.
 */
export function useAccountMenu() {
  const router = useRouter()
  const { forceLogout, isStaff, stopImpersonation } = useUtil(useLogger())

  const studentFullName = computed(() => `${store.getters.user.user?.firstName} ${store.getters.user.user?.lastName}`)

  const doStopImpersonate = () => stopImpersonation(router)

  return { doStopImpersonate, forceLogout, isStaff, studentFullName }
}
